import React from 'react';

import { SITE_CONTACT_LABEL_TEXT } from "./constants";

import styles from './styles.module.scss';

export const ContactItem: React.FC<components.ContactItem> = ({
  contactKey,
  email,
  fullName,
  phone,
  handleChange,
  isSelected,
}) => (
  <div className={styles.wrapper}>
    <label htmlFor={contactKey}>{SITE_CONTACT_LABEL_TEXT}</label>
    <input
      data-testid="contact"
      id={contactKey}
      type="radio"
      name="name"
      checked={isSelected}
      onChange={handleChange}
    />
    <div className={styles.content}>
      <div className={styles.dot} />
      <h4>{fullName}</h4>
      <div className={styles.contact}>
        <h5 className={styles.contactInfo}>Phone number:</h5>
        <p>{phone}</p>
      </div>
      <div className={styles.contact}>
        <h5>Email:</h5>
        <p>{email}</p>
      </div>
    </div>
  </div>
);
